<template>
    <div class = "print" v-if="getPermission.loads.view || getPermission.stc.view">

        <md-tabs md-sync-route class="load-and-bill-tabs">
          <md-tab id="tab-lock_load" md-label="Load" to="/lock/load"></md-tab>
          <md-tab id="tab-lock_stage" md-label="Stage" to="/lock/stage"></md-tab>
          <md-tab id="tab-lock_chassis" md-label="Billing/Cost Report" to="/lock/chassis"></md-tab>
        </md-tabs>
        <router-view/>

    </div>

</template>

<style lang="scss">

  .load-and-bill-tabs {
    .md-tabs-navigation {
      .md-theme-default {
        height: 30px;
      }
    }
  }

  


</style>


<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({}),
    computed: {
      ...mapGetters([
        'getPermission',
        'getMasterDataName',
      ]),
    },
  };

</script>



